import React, { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { VendorOrdersPage } from './VendorOrdersPage';
import { getVendorOrdersData } from 'store/vendorStore/vendorOrders/dispatch';
import { eTitleSearchStatus } from '../../../types/order/title/eTitleSearchStatus';
import { VendorWrapper } from '../../../components/vendorDashboard/VendorWrapper';
import { VendorSelectors } from '../../../selectors/vendorPortal/VendorSelectors';
import { useAppDispatch } from '../../../store/store';

interface IVendorOrdersContainerProps {}

export const VendorOrdersContainer: React.FC<IVendorOrdersContainerProps> = () => {
  const dispatch = useAppDispatch();
  const [updateInformation, setUpdateInformation] = useState(false);
  const { orders, searchSettings, ordersError, ordersFetchStatus } = useSelector(VendorSelectors.selectOrders);

  useEffect(() => {
    if (!updateInformation) {
      // update info if user return from another page
      setUpdateInformation(true);
      dispatch(getVendorOrdersData(searchSettings.statuses, searchSettings.pageSize, searchSettings.page));
    }
  }, [dispatch, searchSettings, updateInformation]);

  const onFilterOrder = (status: eTitleSearchStatus[]) => {
    dispatch(getVendorOrdersData(status, searchSettings.pageSize, searchSettings.page));
  };

  const onPageSizeUpdate = (pageSize: number) => {
    dispatch(getVendorOrdersData(searchSettings.statuses, pageSize, searchSettings.page));
  };

  const onPageUpdate = (page: number) => {
    dispatch(getVendorOrdersData(searchSettings.statuses, searchSettings.pageSize, page));
  };
  const onSearchOrder = (value: any) => {
    dispatch(
      getVendorOrdersData(
        searchSettings.statuses,
        searchSettings.pageSize,
        searchSettings.page,
        value.fileNumber || undefined
      )
    );
  };

  return (
    <VendorWrapper isLoading={ordersFetchStatus.fetching}>
      <VendorOrdersPage
        pageError={ordersError}
        orders={orders}
        searchSettings={searchSettings}
        loadingOrder={ordersFetchStatus.fetching}
        onFilterOrder={onFilterOrder}
        onPageSizeUpdate={onPageSizeUpdate}
        onPageUpdate={onPageUpdate}
        onSearchOrder={onSearchOrder}
      />
    </VendorWrapper>
  );
};
